import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Design tokens must load before anything that consumes them.
import './assets/styles/variables.css';
import './assets/styles/globals.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);